export default __webpack_public_path__ + "static/media/keynote14.faa8b2b7.jpeg";